import { useState, useEffect } from 'react';
import { useAuthContext } from '../../components/AuthProvider'; // Adjust the import path based on your project structure

// Custom hook to fetch and persist business owner ID
export const useBusinessOwnerId = () => {
    const [businessOwnerId, setBusinessOwnerId] = useState(sessionStorage.getItem('tos-businessOwnerId') || null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { loginUser, token } = useAuthContext();
    const userId = loginUser?.id;

    useEffect(() => {
        const fetchBusinessOwnerId = async () => {
            // Check if businessOwnerId is already in sessionStorage
            const storedBusinessOwnerId = sessionStorage.getItem('tos-businessOwnerId');
            if (storedBusinessOwnerId) {
                setBusinessOwnerId(storedBusinessOwnerId);
                return;
            }

            if (!userId) {
                setError('User ID not found in authentication context');
                return;
            }

            setLoading(true);
            try {
                // Fetch business owners data from the endpoint
                const response = await fetch('https://api.synergytoss.net/api/v1/businessowners', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include token for authentication
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const businessOwners = await response.json();

                // Filter the business owners array to find the matching userId
                const businessOwner = businessOwners.find(owner => owner.userId === userId);

                if (!businessOwner) {
                    throw new Error('No business owner found for the provided user ID');
                }

                // Set and store the business owner ID
                setBusinessOwnerId(businessOwner.id);
                sessionStorage.setItem('tos-businessOwnerId', businessOwner.id);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBusinessOwnerId();
    }, [userId, token]);

    return { businessOwnerId, loading, error };
};